// Components
import { GroupSettingsForm } from "../groupSettingsForm/GroupSettingsForm";
import { RosterSettingsForm } from "../rosterSettingsForm/RosterSettingsForm";
import { ContainerType } from "@ms/planner-models/lib/local/service/planner/enumerations/IPlannerEnumerations";
// Styles
import { useContainerSettingsFormStyles } from "./ContainerSettingsForm.styles";
// Utilities
import * as React from "react";
/**
 * ContainerSettingsForm component renders container-specific settings
 * based on the plan's container type
 */ export const ContainerSettingsForm = (props)=>{
    const { plan, modernGroup, isGroupOwner, sensitivityLabels, onUpdateGroupSettings, isUpdatingGroupSettings, isGroupSettingsCollapsible, plannerRoster, hasSharedContainers, enableMIPLabels, userAccessibleTenantSensitivityLabels, canChangeSensitivity, onSaveHandlerChange, onHasChangesChange, onSaveDisabledChange, onSensitivitySelected } = props;
    const styles = useContainerSettingsFormStyles();
    // Handle state changes from child components
    const handleStateChange = React.useCallback((hasChanges, saveHandler, saveDisabled)=>{
        if (onHasChangesChange) {
            onHasChangesChange(hasChanges);
        }
        if (onSaveHandlerChange) {
            onSaveHandlerChange(saveHandler);
        }
        if (onSaveDisabledChange) {
            onSaveDisabledChange(saveDisabled);
        }
    }, [
        onHasChangesChange,
        onSaveHandlerChange,
        onSaveDisabledChange
    ]);
    // Render container-specific settings based on container type
    const containerType = plan.container.containerType;
    switch(containerType){
        case ContainerType.Group:
            return /*#__PURE__*/ React.createElement("div", {
                className: styles.container
            }, /*#__PURE__*/ React.createElement(GroupSettingsForm, {
                modernGroup: modernGroup,
                isGroupOwner: isGroupOwner,
                sensitivityLabels: sensitivityLabels,
                onUpdateGroupSettings: onUpdateGroupSettings,
                isUpdatingGroupSettings: isUpdatingGroupSettings,
                isCollapsible: isGroupSettingsCollapsible,
                currentSensitivityLabelId: props.currentSensitivityLabelId,
                onStateChange: handleStateChange
            }));
        case ContainerType.Roster:
            // Only render if plannerRoster is available
            if (!plannerRoster) {
                return null;
            }
            return /*#__PURE__*/ React.createElement("div", {
                className: styles.container
            }, /*#__PURE__*/ React.createElement(RosterSettingsForm, {
                plannerRoster: plannerRoster,
                hasSharedContainers: hasSharedContainers,
                enableMIPLabels: enableMIPLabels,
                userAccessibleTenantSensitivityLabels: userAccessibleTenantSensitivityLabels,
                canChangeSensitivity: canChangeSensitivity,
                onSensitivitySelected: onSensitivitySelected
            }));
        default:
            // For all other container types (User, Project, TeamsChannel, DriveItem, etc.)
            // No container-specific settings to display
            return null;
    }
};
